import Accordion from '../../components/accordion';

export default class AccountIndex { 
  constructor(){
    Accordion();
  }
}